
export default require('../otherChains/somniaTestnet').default.rpcUrls.default.http[0]